import React from 'react';
import TrouveEcole from '../../RechercheEcole/TrouveEcole';

const ChoixEcole = ({ setEcole_selection, code_dept, cheminpush }) => {
  return (
    <div>
      <TrouveEcole
        setEcole_selection={setEcole_selection}
        code_dept={code_dept}
        cheminpush={cheminpush}
      />
    </div>
  );
};

export default ChoixEcole;
